import { forwardRef, useImperativeHandle, useMemo } from 'react';
import { Select } from 'antd';
import { FocusRef } from '../../components';
import { FilterInputProps } from './FilterInputProps';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { createFocusHandle, createOnBlur } from './focusHandlers';
import translations from './BooleanSelectFilterInput.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'boolean-select-filter-input'
);
addTranslations(translations);

export const BooleanSelectFilterInput = forwardRef<FocusRef, FilterInputProps>(
  (props, ref) => {
    const { header, onBlur } = props;
    const { t } = useTranslation();
    const id = `${header.column.id}-filter-input`;

    useImperativeHandle(ref, () => createFocusHandle(id));
    const handleOnBlur = useMemo(
      () => createOnBlur<HTMLInputElement>(id, onBlur),
      [id, onBlur]
    );

    const options = useMemo(
      () => [
        {
          value: true,
          label: t('yes'),
        },
        {
          value: false,
          label: t('no'),
        },
      ],
      [t]
    );

    const handleChange = (value?: boolean) => {
      header.column.setFilterValue(value ?? null);
    };

    const value = header.column.getFilterValue() as boolean | null;

    return (
      <Select
        id={id}
        className={id}
        placeholder={t('placeholder')}
        options={options}
        value={value === null ? undefined : value}
        onChange={handleChange}
        onBlur={handleOnBlur}
        styles={{
          popup: { root: { width: 'max-content' } },
        }}
        allowClear
        style={{ minWidth: 'max-content' }}
        defaultOpen
      />
    );
  }
);
